/* eslint-disable */ 
var myID = document.getElementById('searchCTA');

if ( myID != null ) {

// Define a function to handle scrolling
var myScrollFunc = function () {
    var y = window.scrollY; // Get the vertical scroll position

    // Check if scroll position is greater than or equal to 800 pixels
    if (y >= 400) {
        // If true, add the 'show' class and remove the 'hide' class
        myID.classList.remove('hide');
        myID.classList.add('show');
    } else {
        // If false, add the 'hide' class and remove the 'show' class
        myID.classList.remove('show');
        myID.classList.add('hide');
    }
};

// Add event listener for the 'scroll' event on the window
window.addEventListener('scroll', myScrollFunc);

}    
/* eslint-enable */ 